import Swiper, { Pagination } from "swiper";

export const agence = () => {
  const classes = {
    hidden: "is-hidden",
    active: "is-active",
    showAll: "show-all",
  };

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  //Bloc Sticky anchors
  const anchorsSelectors = {
    anchorsMenu: "[js-sticky-anchors]",
    anchorsWrapper: "[js-anchors-wrapper]",
  };
  const anchorsMenu = document.querySelector(anchorsSelectors.anchorsMenu);

  // Set observer to detect active section and set active anchor
  const handleActiveSection = (anchorsMenu, sections) => {
    const rootMargin = anchorsMenu
      ? `${anchorsMenu.offsetHeight * -1}px 0px ${
          (window.innerHeight - anchorsMenu.offsetHeight - 20) * -1
        }px 0px`
      : "0px";

    const options = {
      rootMargin: rootMargin,
      threshold: 0,
    };

    const onIntersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveAnchor(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(onIntersect, options);

    sections.forEach((section) => {
      observer.observe(section);
    });
  };

  const setActiveAnchor = (id) => {
    const activeAnchor = anchorsMenu.querySelector(`[href="#${id}"]`);
    const anchorsWrapper = anchorsMenu.querySelector(
      anchorsSelectors.anchorsWrapper
    );
    if (activeAnchor) {
      anchorsMenu.querySelectorAll("a").forEach((anchor) => {
        anchor.classList.remove(classes.active);
      });
      activeAnchor.classList.add(classes.active);

      if (isMobile) {
        const targetOffset = activeAnchor.offsetLeft - 32;
        anchorsWrapper.scroll({
          top: 0,
          left: targetOffset,
          behavior: "smooth",
        });
      }
    }
  };

  if (anchorsMenu) {
    const anchors = [
      "notreEquipe",
      "nosServices",
      "temoignages",
      "offresEmploi",
    ];

    let sections = [];
    anchors?.forEach((anchor) => {
      const targetSection = document.getElementById(anchor);
      if (targetSection) {
        sections = [...sections, targetSection];
      }
    });

    handleActiveSection(anchorsMenu, sections);
  }

  //Bloc équipe
  const teamSlider = document.querySelector("[js-team-slider]");

  if (teamSlider) {
    const swiper = new Swiper(teamSlider, {
      modules: [Pagination],
      init: false,
      speed: 500,
      effect: "slide",
      slidesPerView: 1.2,
      spaceBetween: 16,
      grabCursor: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    });

    swiper.init();
  }

  //Bloc Intervention
  const interventionSelectors = {
    bloc: "[js-agency-intervention]",
    contentToggler: "[js-toggle-content]",
    cityNumberToggler: "[js-toggle-city-number]",
    content: "[js-content]",
    cityItem: "[js-agence-city]",
  };

  const interventionBloc = document.querySelector(interventionSelectors.bloc);

  if (interventionBloc) {
    const contentToggler = interventionBloc.querySelector(
      interventionSelectors.contentToggler
    );
    const cityNumberToggler = interventionBloc.querySelector(
      interventionSelectors.cityNumberToggler
    );
    const content = interventionBloc.querySelector(
      interventionSelectors.content
    );

    if (contentToggler && content) {
      contentToggler.addEventListener("click", () => {
        content.classList.toggle(classes.hidden);
        contentToggler.classList.toggle("show-content");
        if (contentToggler.classList.contains("show-content")) {
          contentToggler.innerHTML = "Afficher nos zones d'intervention";
        } else {
          contentToggler.innerHTML = "Masquer nos zones d'intervention";
        }
      });
    }

    if (cityNumberToggler) {
      cityNumberToggler.addEventListener("click", () => {
        content.classList.toggle(classes.showAll);
        if (content.classList.contains(classes.showAll)) {
          cityNumberToggler.innerHTML = "Voir moins de villes";
        } else {
          cityNumberToggler.innerHTML = "Voir plus de villes";
        }
      });
    }
  }

  //Bloc  nos agences à proximité
  const agenciesSelectors = {
    bloc: "[js-agency-agencies]",
    contentToggler: "[js-toggle-content]",
    content: "[js-content]",
  };

  const agenciesBloc = document.querySelector(agenciesSelectors.bloc);

  if (agenciesBloc) {
    const contentToggler = agenciesBloc.querySelector(
      agenciesSelectors.contentToggler
    );
    const content = agenciesBloc.querySelector(agenciesSelectors.content);

    if (contentToggler && content) {
      contentToggler.addEventListener("click", () => {
        content.classList.toggle(classes.hidden);
        contentToggler.classList.toggle("show-content");
        if (contentToggler.classList.contains("show-content")) {
          contentToggler.innerHTML = "Afficher la liste des agences";
        } else {
          contentToggler.innerHTML = "Masquer la liste des agences";
        }
      });
    }
  }

  //Tracking Fiche agence
  window.dataLayer = window.dataLayer || [];
  function pushToDataLayer(event) {
    let classes = event.target.classList;
    let id = event.target.id;
    let intervention = document.querySelector(".intervention-accordion");
    let agence = document.querySelector(".agence-accordion");
    let service = event.target.closest('.elementor-icon-list-item');

    // Clic des accordéons agence et intervention
    if (agence && agence.contains(event.target)) {
      let agenceActive = agence.classList.contains("active");
      if (agenceActive == true) {
        dataLayer.push({
          event: "click_zone",
          event_id: "agence",
        });
      }
    }
    if (intervention && intervention.contains(event.target) && id != "agglo")  {
      let interventionActive = intervention.classList.contains("active");
      if (interventionActive == true) {
        dataLayer.push({
          event: "click_zone",
          event_id: "intervention",
        });
      }
    }
    // Clic des CTA Demande de devis
    if (classes.contains("devis-btn")) {
      dataLayer.push({
        event: "click_devis",
        event_id: "header",
      });
    }
    if (classes.contains("devis-ccm")) {
      dataLayer.push({
        event: "click_devis",
        event_id: "medium",
      });
    }
    if (id == "devis-service") {
      dataLayer.push({
        event: "click_devis",
        event_id: "footer",
      });
    }
    // Clic des numéros de téléphone
    if (classes.contains("tel-agence")) {
      dataLayer.push({
        event: "click_contact",
        event_id: "header",
      });
    }
    if (classes.contains("item-tel")) {
      dataLayer.push({
        event: "click_contact",
        event_id: "cadre",
      });
    }
    if (classes.contains("link-job")) {
      dataLayer.push({
          event: "click_offre",
          event_name: event.target.dataset.name,
          event_id: event.target.dataset.position
      });
    }
    if(service){
        dataLayer.push({
            event: "click_service",
            service_name: event.target.innerText,
        });
    }
  }
  const agenceAction = document.querySelector(".agence-wrapper");
  if (agenceAction) {
    agenceAction.addEventListener("click", pushToDataLayer);
  }
  const inteventionAction = document.querySelector(".intervention-wrapper");
  if (inteventionAction) {
    inteventionAction.addEventListener("click", pushToDataLayer);
  }

  const links = document.querySelectorAll(".nos-agences a");
  links.forEach((link) => {
    link.addEventListener("click", pushToDataLayer);
  });
};
